/**
 * Calculate the number of buttons being visible.
 *
 * @param {number} availableWidth			- Width that is available for the button container
 * @param {[number]} buttonWidths			- Widths of all buttons in the container
 * @param {number} moreButtonWidth			- Width of the more button
 * @param {number} gap						- The space between elements
 * @param {number} [additionalContentWidth]	- Width of optional additional content
 * @return {number}
 */
export function getNumberVisibleButtons(availableWidth, buttonWidths, moreButtonWidth, gap, additionalContentWidth) {
    if (!availableWidth || !moreButtonWidth) {
        return 0
    }

    let numVisibleButtons = 0
    let numVisibleButtonsWithMoreButton = 0
    buttonWidths.reduce((remainingWidth, width, index) => {
        const currentWidth = remainingWidth - width

        if (currentWidth >= 0) {
            // still enough space, button is visible
            numVisibleButtons = index + 1

            if (currentWidth - (gap + moreButtonWidth) >= 0) {
                numVisibleButtonsWithMoreButton = numVisibleButtonsWithMoreButton + 1
            }
            return currentWidth - gap
        }

        // but is not visible, the moreButton must be shown
        if (remainingWidth - moreButtonWidth >= 0) {
            return 0
        } else {
            // set number of visible buttons to last number fitting with more button
            numVisibleButtons = numVisibleButtonsWithMoreButton
            return 0
        }
    }, availableWidth - (additionalContentWidth ? additionalContentWidth + gap : 0))
    return numVisibleButtons
}
